<template>
  <div class="basicInfoContent">
    <el-collapse v-model="activeNames">
      <el-collapse-item name="base">
        <template #title>
          <span>
            <img src="../../assets/svg/bsaicIcon.svg" alt="" />
            基本信息
          </span>
        </template>
        <el-descriptions :column="3" border>
          <el-descriptions-item
            v-for="(label, key) in fieldLabels"
            :key="key"
            :label="label"
            :prop="key"
          >
            <span v-if="key === 'carType'">
              {{ carTypeMap[basicList[key]] }}
            </span>
            <span v-else-if="key === 'taskStatus'">
              {{ taskStatusMap[basicList[key]] }}
            </span>
            <span v-else>
              {{ basicList[key] }}
            </span>
          </el-descriptions-item>
        </el-descriptions>
      </el-collapse-item>
    </el-collapse>
  </div>
</template>
<script>
export default {
  name: "basicInfo",
  data() {
    return {
      activeNames: ["base"], // 全部展开
      // 字段映射
      fieldLabels: {
        infoSubject: "信息主题",
        questionNum: "问题序号",
        feedbackFormId: "反馈单号",
        country: "国家",
        carType: "故障来源",
        creator: "提交人",
        submitTime: "提交时间",
        people: "当前处理人",
        taskStatus: "状态",
      },
      carTypeMap: {
        0: "售前车",
        1: "售后车",
      },
      taskStatusMap: {
        0: "待处理",
        1: "处理中",
        2: "已关闭",
      },
    };
  },
  props: {
    basicList: {
      type: [Array, Object],
      default: () => [],
    },
  },
};
</script>
